import { render, staticRenderFns } from "./SubmissionSearch.vue?vue&type=template&id=cec55c40"
import script from "./SubmissionSearch.vue?vue&type=script&lang=js"
export * from "./SubmissionSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports